/*
 *  Header Section
 *
 *  Version:
 *    1.0.0 - 2020/08/13
 */

import { register, ShopifySection } from './../../sections/ShopifySection';
// import * as ResponsiveSizes from './../../settings/Responsive';

export const SELECTOR_CONTAINER = '[data-header-wrapper]';
export const STICKY_OUTER       = '[data-main-header-outer]';
export const STICKY_INNER       = '[data-main-header]';
export const STICKY_CLASS       = 'is-sticky';
export const STICKY_OUT_CLASS   = 'is-animate-out';
export const STICKY_OFFSET      = 500;
export const STICKY_WAIT_DELAY  = 1000;

let isWaiting                   = false;
let startHeader                 = 0;

export class HeaderWrapper extends ShopifySection {
  constructor(container) {
    super(container);

    this.container = container;
    this.stickyOuter = container.find(STICKY_OUTER);
    this.stickyInner = container.find(STICKY_OUTER);
    this.lastScroll = 0;

    if(this.stickyOuter.length < 1) {
      return;
    }

    this.resetHeader();

    $(window).on('scroll', () => this.headerOnScroll());
    $(window).on('resize orientationchange', () => this.resetHeader());
  }

  headerOnScroll() {
    if(!isWaiting) {
      if((window.scrollY < this.lastScroll)) {
        // scrolling up
        this.stickHeader();
      } else if (window.scrollY > STICKY_OFFSET) {
        // scrolling down
        this.unstickHeader();
      }
    }
    if (window.scrollY < startHeader) {
      this.resetHeader();
    }
    this.lastScroll = window.scrollY;
  }

  stickHeader() {

    let headerHeight = this.stickyOuter.get(0).getBoundingClientRect().height;
    this.stickyOuter.css('height', headerHeight);
    this.stickyOuter.removeClass(STICKY_OUT_CLASS);
    this.stickyOuter.addClass(STICKY_CLASS);
    this.startWait();
  }

  unstickHeader() {

    if(this.stickyOuter.hasClass(STICKY_CLASS)) {
      this.stickyOuter.removeClass(STICKY_CLASS);
      this.stickyOuter.addClass(STICKY_OUT_CLASS);
      this.startWait();
    }
  }

  resetHeader() {

    startHeader = this.stickyOuter.get(0).getBoundingClientRect().y + window.scrollY;
    this.stickyOuter.css('height', '');
    this.stickyOuter.removeClass(STICKY_CLASS);
    this.stickyOuter.removeClass(STICKY_OUT_CLASS);
  }

  startWait() {
    isWaiting = true;
    window.setTimeout(function() {
      isWaiting = false;
    }, STICKY_WAIT_DELAY);
  }

}

register(SELECTOR_CONTAINER, HeaderWrapper);
